<template>
  <div>
    <div class="row" v-if="dashboard">
      <div class="col-md-12">
        <div class="card card-stats card-raised">
          <div class="card-body">
            <div class="row">

              <div class="col-md-3">
                <div class="statistics">
                  <div class="info">
                    <div class="icon icon-primary">
                      <i class="now-ui-icons education_hat"></i>
                    </div>
                    <h3 class="info-title">
                      <animated-number :value="dashboard.students"></animated-number>
                    </h3>
                    <h6 class="stats-title">Students</h6>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="statistics">
                  <div class="info">
                    <div class="icon icon-success">
                      <i class="now-ui-icons education_glasses"></i>
                    </div>
                    <h3 class="info-title">
                      <!-- <small>$</small> -->
                      <animated-number :value="dashboard.teachers"></animated-number>
                    </h3>
                    <h6 class="stats-title">Teachers</h6>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="statistics">
                  <div class="info">
                    <div class="icon icon-info">
                      <i class="now-ui-icons users_single-02"></i>
                    </div>
                    <h3 class="info-title">
                      <animated-number :value="dashboard.admins"></animated-number>
                    </h3>
                    <h6 class="stats-title">Admins</h6>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="statistics">
                  <div class="info">
                    <div class="icon icon-danger">
                      <i class="now-ui-icons users_circle-08"></i>
                    </div>
                    <h3 class="info-title">
                      <animated-number :value="dashboard.superadmins"></animated-number>
                    </h3>
                    <h6 class="stats-title">Super Admins</h6>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row"  v-if="dashboard">

      <div class="col-lg-4">
        <card class="card-chart" no-footer-line>
          <div slot="header">
            <h5 class="card-category">Glimpses News</h5>
            <h2 class="card-title">
              <animated-number :value="chartNews.total"></animated-number>
            </h2>
          </div>
          <div class="chart-area">
            <line-chart :labels="chartNews.labels" 
                        :data="chartNews.data" 
                        :color="chartNews.color"
                        :title="chartNews.title" 
                        :height="200">
            </line-chart>
          </div>
          <div slot="footer" class="stats">
            <i class="now-ui-icons arrows-1_refresh-69"></i> Just Updated
          </div>
        </card>
      </div>

      <div class="col-lg-4">
        <card class="card-chart" no-footer-line>
          <div slot="header">
            <h5 class="card-category">Circulars in {{currentMonth}}</h5>
            <h2 class="card-title">
              <animated-number :value="chartNotices.total"></animated-number>
            </h2>
          </div>
          <div class="chart-area">
            <line-chart :labels="chartNotices.labels"
                       :data="chartNotices.data"
                       :color="chartNotices.color"
                       :title="chartNotices.title"
                       :height="200">
            </line-chart>
          </div>
          <div slot="footer" class="stats">
            <i class="now-ui-icons arrows-1_refresh-69"></i> Just Updated
          </div>
        </card>
      </div>

      <div class="col-lg-4">
        <card class="card-chart" no-footer-line>
          <div slot="header">
            <h5 class="card-category">Highlights in {{ currentMonth }}</h5>
            <h2 class="card-title">
              <animated-number :value="chartToday.total"> </animated-number>
            </h2>
          </div>
          <div class="chart-area">
            <line-chart :labels="chartToday.labels"
                       :data="chartToday.data"
                       :color="chartToday.color"
                       :title="chartToday.title"
                       :height="200">
            </line-chart>
          </div>
          <div slot="footer" class="stats">
            <i class="now-ui-icons arrows-1_refresh-69"></i> Just Updated
          </div>
        </card>
      </div>

    </div>
    
  </div>
</template>
<script>
import { StatsCard, Card, Table as NTable, Checkbox, AnimatedNumber, Progress as NProgress, AsyncWorldMap } from 'src/components';
import LineChart from 'src/components/Charts/LineChart';
import { mapGetters } from 'vuex'

const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export default {
  components: {
    Checkbox,
    Card,
    NTable,
    StatsCard,
    AnimatedNumber,
    LineChart,
    NProgress,
    AsyncWorldMap
  },
  mounted(){
    this.$store.dispatch('getDashboard', 'admin')
  },
  computed: {
    ...mapGetters({
        dashboard: 'getDashboard'
    }),
    currentMonth(){
      return months[new Date().getMonth()];
    },
    chartNews(){
        return {
          total: this.dashboard.news.reduce((accumulator, currentValue, currentIndex, array) => { return accumulator + currentValue.count; }, 0),
          labels: this.dashboard.news.map((item) => `${months[item._id.month - 1].slice(0,3)} ${item._id.year}`),
          data: this.dashboard.news.map((item) => item.count),
          color: '#f96332',
          title: 'Data'
        }
    },
    chartNotices(){
        return {
          total: this.dashboard.notice.reduce((accumulator, currentValue, currentIndex, array) => { return accumulator + currentValue.count; }, 0),
          labels: this.dashboard.notice.map((item) => `${this.currentMonth.slice(0,3)} ${item.day}`),
          data: this.dashboard.notice.map((item) => item.count),
          color: '#18ce0f',
          title: 'Data'
        }
    },
    chartToday(){
        return {
          total: this.dashboard.today.reduce((accumulator, currentValue, currentIndex, array) => { return accumulator + currentValue.count; }, 0),
          labels: this.dashboard.today.map((item) => `${this.currentMonth.slice(0,3)} ${item.day}`),
          data: this.dashboard.today.map((item) => item.count),
          color: '#2CA8FF',
          title: 'Data'
        }
    }
  },
  data() {
    return {
      progress: 0
    };
  }
};
</script>
<style lang="scss">
</style>
